import { instanceOf, string } from 'prop-types'
import cn from 'classnames'

import Icon from '../../../icon/index.js'
import PostText from '../../theme-components/post-text.js'
import SocialCommerce from '../../theme-components/social-commerce.js'
import Post from '../../../../../models/Post.js'
import Settings from '../../../../../models/settings.js'

export default function CarouselPostContent({ feedKey, post, settings }) {
  const {
    feedFontSize,
    isMinimalistic,
    socialCommerceButtonPosition,
    allowCookies,
    enableWebAnalytics,
  } = settings

  return !isMinimalistic ? (
    <div
      className={cn('bzfy-o-body', {
        'bzfy-o-body--no-image': !post.hasMedia,
      })}
      style={{ fontSize: feedFontSize }}
    >
      {settings.showPostText && (
        <p className="bzfy-o-body__content">
          {settings.showPostText && (
            <PostText hashtagColor={settings.hashtagColor} maxLength={140} postText={post.text} />
          )}
        </p>
      )}
      {socialCommerceButtonPosition === 'bottom' && (
        <div>
          <SocialCommerce
            allowCookies={allowCookies}
            className={cn('bzfy-o-commerce', {
              'bzfy-o-commerce--large': settings.socialCommerceButtonLarge,
              'bzfy-o-commerce--image': socialCommerceButtonPosition === 'top',
              'bzfy-o-commerce--bottom': socialCommerceButtonPosition === 'bottom',
            })}
            enableWebAnalytics={enableWebAnalytics}
            feedKey={feedKey}
            fromGate={false}
            post={post}
            settings={settings}
            target="_blank"
          />
        </div>
      )}
      {settings.showPlatformIcon && (
        <div aria-hidden="true" className="bzfy-o-social">
          <Icon
            className="bzfy-o-social__icon"
            color={settings.postColor}
            icon={`social-${post.sourceName}`}
          />
        </div>
      )}
    </div>
  ) : null
}

CarouselPostContent.propTypes = {
  feedKey: string.isRequired,
  post: instanceOf(Post).isRequired,
  settings: instanceOf(Settings).isRequired,
}
